import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
// import { InhftWorkDetail } from './employeenewhireworkdetail';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';
import { stringify } from 'querystring';

@Injectable()
export class MonthleypaidService {

  private epcaresUrl = CONFIGURATION.baseServiceUrl;
  private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';

  constructor(private _http: Http) { }

  getReportData(): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.epcaresUrl + 'monthlypaidempservice/referencedata', { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }
  getSsnData(ssnData: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    let fileName = 'ssnreportdata?Ssn=' + ssnData.ssn
    + '&TaxYear=' + ssnData.taxyear
    + '&ControlGroup=' + ssnData.controlgroup
    + '&ReportName=' + 'MonthlyPaidEmpservice';
    return this._http.get(this._ssnUrl + fileName, { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }

  getEligibleFullTimeWorkers(filterCriteria: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.epcaresUrl + `monthlypaidempservice/reportdata?WorkYear=${filterCriteria.selectedYear}&WorkMonth=${filterCriteria.selectedHireMonth}&ControlGroup=${filterCriteria.selectedControlGroup}`, { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }


  downloadExcelReport(filterCriteria: any): any {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.epcaresUrl + `monthlypaidempservice/excel-download?WorkYear=${filterCriteria.selectedYear}&WorkMonth=${filterCriteria.selectedHireMonth}&ControlGroup=${filterCriteria.selectedControlGroup}`,
      { headers: headers, responseType: ResponseContentType.Blob }).map(
        (res) => {
          const a = document.createElement('a');
          document.body.appendChild(a);
          const blob = new Blob([res.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const downloadUrl = URL.createObjectURL(blob);
          window.open(downloadUrl);
        })
  }

  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }

}



// WEBPACK FOOTER //
// ./src/app/monthlypaidemployees/monthleypaid.service.ts